import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.56 15.56" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 4" stroke="fj-icons-primary-color">
        <rect
          x={0.28}
          y={0.28}
          width={15}
          height={15}
          rx={3}
          ry={3}
          fill="fj-icons-bg-color"
          strokeMiterlimit={10}
          strokeWidth={0.56}
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3.28 9.13l3.22 3.21 5.78-9.12"
        />
      </g>
    </g>
  </svg>
);

const AcceptBordered = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default AcceptBordered;
